import React, { useState } from 'react';

const SimpleTestApp = () => {
  const [selectedRole, setSelectedRole] = useState(null);

  const roles = [
    {
      id: 'superadmin',
      title: 'Super Admin',
      credentials: 'admin@gpstracking.com / admin123',
      url: '/school.html?role=superadmin'
    },
    {
      id: 'agency',
      title: 'Agency',
      credentials: 'agency@gpstracking.com / agency123',
      url: '/agency-login.html'
    },
    {
      id: 'school',
      title: 'School Admin', 
      credentials: 'school@greenvalley.edu / school123',
      url: '/school.html'
    },
    {
      id: 'parent',
      title: 'Parent',
      credentials: 'Phone: 9876543210 (OTP)',
      url: '/'
    }
  ];

  const handleRoleSelect = (role) => {
    if (role.id === 'superadmin') {
      // Simple Super Admin login
      localStorage.setItem('token', 'test-admin-token');
      localStorage.setItem('user', JSON.stringify({
        id: 1,
        name: 'Super Admin',
        email: 'admin@gpstracking.com',
        role: 'admin'
      }));
      window.location.reload();
    } else if (role.id === 'agency') {
      // Agency login - open in new tab
      window.open(role.url, '_blank');
    } else if (role.id === 'school') {
      // Simple School Admin login
      localStorage.setItem('token', 'test-school-token');
      localStorage.setItem('user', JSON.stringify({
        id: 2,
        name: 'School Admin',
        email: 'school@greenvalley.edu',
        role: 'school'
      }));
      window.location.reload();
    } else {
      // Parent login
      window.open(role.url, '_blank');
    }
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>GPS Tracking System - Test Environment</h1>
      <p>Choose a role to test:</p>
      
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px' }}>
        {roles.map((role) => (
          <div 
            key={role.id}
            style={{
              border: '2px solid #ddd',
              borderRadius: '10px',
              padding: '20px',
              textAlign: 'center',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onClick={() => handleRoleSelect(role)}
            onMouseOver={(e) => {
              e.target.style.borderColor = '#1976d2';
              e.target.style.transform = 'translateY(-2px)';
            }}
            onMouseOut={(e) => {
              e.target.style.borderColor = '#ddd';
              e.target.style.transform = 'translateY(0)';
            }}
          >
            <h3>{role.title}</h3>
            <p><strong>Test Credentials:</strong></p>
            <p>{role.credentials}</p>
            <button 
              style={{
                background: '#1976d2',
                color: 'white',
                border: 'none',
                padding: '10px 20px',
                borderRadius: '5px',
                cursor: 'pointer'
              }}
            >
              Login as {role.title}
            </button>
          </div>
        ))}
      </div>

      <div style={{ marginTop: '30px', padding: '20px', background: '#f5f5f5', borderRadius: '5px' }}>
        <h3>Setup Instructions:</h3>
        <ol>
          <li>Backend: <code>cd backend && npm start</code></li>
          <li>Frontend: <code>cd frontend && npm start</code></li>
          <li>Test Data: <code>cd backend && node create-test-data.js</code></li>
        </ol>
      </div>
    </div>
  );
};

export default SimpleTestApp;